import { getAlmeSessionData } from '../AlmeAppSessionState';
function createHostPageDataObject() {
    var _a;
    return {
        PageInfo: window._SFDDL,
        AlmeUserID_PreLogin: (_a = getAlmeSessionData()) === null || _a === void 0 ? void 0 : _a.userId,
    };
}
async function sendInitialAppEvents(almeApiUtils, almeState) {
    const responses = [];
    try {
        const hostPageDataParams = createHostPageDataObject();
        const hostPageDataResponse = await almeApiUtils.sendAppEvent('HostPageData', undefined, hostPageDataParams);
        if (hostPageDataResponse) {
            responses.push(hostPageDataResponse);
        }
        const launchParams = {
            LaunchPointName: almeState.launchPointName || "",
            LaunchParameter: almeState.launchParameter || "",
            LaunchType: 'Reactive',
        };
        const welcomeResponse = await almeApiUtils.sendAppEvent('WelcomeUser', undefined, launchParams);
        if (welcomeResponse) {
            responses.push(welcomeResponse);
        }
    }
    catch (error) {
        console.error(error);
    }
    return responses;
}
export default sendInitialAppEvents;
